import { DashboardMetricCard, DashboardMetricGrid } from '@yeshuman/sdk'
import { Thermometer, Scale, HeartPulse, Activity } from 'lucide-react'

import type { MeasurementItem } from '../hooks/use-measurements'

const LB_PER_KG = 2.20462262185

interface MeasurementStatsProps {
  measurements: MeasurementItem[]
}

export function MeasurementStats({ measurements }: MeasurementStatsProps) {
  const weights = measurements.filter((m) => m.measurement_type === 'body_weight')
  const bp = measurements.filter((m) => m.measurement_type === 'blood_pressure')
  const hr = measurements.filter((m) => m.measurement_type === 'heart_rate')

  const latestWeight = weights.sort(
    (a, b) => new Date(b.measured_at).getTime() - new Date(a.measured_at).getTime(),
  )[0]

  const kgToLb = (kg: string) => {
    const n = Number.parseFloat(kg)
    if (Number.isNaN(n)) return '—'
    return (n * LB_PER_KG).toFixed(1)
  }

  return (
    <DashboardMetricGrid maxColumns={4}>
      <DashboardMetricCard
        title="Total readings"
        value={measurements.length}
        description="In current filter"
        icon={Thermometer}
      />
      <DashboardMetricCard
        title="Latest weight"
        value={latestWeight?.mass_kg != null ? `${latestWeight.mass_kg} kg` : '—'}
        description={
          latestWeight?.mass_kg != null
            ? `${kgToLb(latestWeight.mass_kg)} lb`
            : 'Log a weight reading'
        }
        icon={Scale}
      />
      <DashboardMetricCard
        title="Blood pressure"
        value={bp.length}
        description="Readings logged"
        icon={HeartPulse}
      />
      <DashboardMetricCard
        title="Heart rate"
        value={hr.length}
        description="Readings logged"
        icon={Activity}
      />
    </DashboardMetricGrid>
  )
}
